const replacements = {
  journal: 'diary'
}

export function file(file) {
  return {
    id: file.id,
    modelId: file.modelId,
    modelType: replacements[file.modelType] || file.modelType,
    type: file.fileType || 'image',
    url: file.url,
  }
}
